<template>
  <main id="main">
    <div class="l-contents">
      <div class="l-btn">
        <div class="btn-basic" @click="goDiagMasterList()"><a>監査マスタ</a></div>
        <div class="btn-basic" @click="goDiagCourseList()"><a>診断コースマスタ</a></div>
        <div class="btn-basic" @click="goRoughDiagMasterList()"><a>小テストマスタ</a></div>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  methods: {
    goDiagMasterList() {
      this.$store.dispatch('master/setVerId', 5);
      this.$router.push({ name: 'diag-master-list' } );
    },
    goDiagCourseList() {
      this.$router.push({ name: 'diag-course-list' });
    },
    goRoughDiagMasterList() {
      this.$router.push({ name: 'rough-diag-master-list' });
    }
  }
}
</script>
